$(document).ready(function(){
    setInterval(function(){
        if($('.fullscreen_content_panel').length>0)
        {
            $('.fullscreen_content_panel').css({height:Math.ceil($(window).height() - $('#page_header').outerHeight())+'px'});
        }
    },1000);
});